export default {"src":"/_next/static/media/logo.326c3ce6.svg","height":347,"width":1611,"blurWidth":0,"blurHeight":0};